import { useState } from "react";

const Modal = ({ isOpen, onClose, title, modalId, children }) => {

    if (!isOpen) return null;

    return (
        <>
            {isOpen && (
                <div className="modal-backdrop fade show" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 1)', zIndex: 1040, }}></div>
            )}
            <div className={`modal fade ${isOpen ? 'show' : ''}`} tabIndex="-1" id={modalId} aria-labelledby="exampleModalLabel"  aria-hidden={!isOpen ? 'true' : 'false'} style={{ display: isOpen ? ('block') : ('none') }}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">{title}</h1>
                            <button type="button" onClick={onClose} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {children}
                        </div>
                    </div>
                </div>  
            </div>
        </>
    );
}

export default Modal;